import { render, staticRenderFns } from "./CustomerDetailsFieldset.vue?vue&type=template&id=1eb4c3c9"
import script from "./CustomerDetailsFieldset.vue?vue&type=script&lang=ts"
export * from "./CustomerDetailsFieldset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports